var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 31,
    viewBox: "0 0 39 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 3.3125V27.6875C38.25 28.4375 37.9688 29.0937 37.4062 29.6562C36.8438 30.2187 36.1875 30.5 35.4375 30.5H3.5625C2.8125 30.5 2.15625 30.2187 1.59375 29.6562C1.03125 29.0937 0.75 28.4375 0.75 27.6875V3.3125C0.75 2.5625 1.03125 1.90625 1.59375 1.34375C2.15625 0.78125 2.8125 0.5 3.5625 0.5H35.4375C36.1875 0.5 36.8438 0.78125 37.4062 1.34375C37.9688 1.90625 38.25 2.5625 38.25 3.3125ZM3.5625 8.42188H35.4375V3.3125H3.5625V8.42188ZM3.5625 14.4688V27.6875H35.4375V14.4688H3.5625ZM3.5625 27.6875V3.3125V27.6875Z",
    fill: "#F4F4F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.0eaf90ac9d1b58a8eb7c6700f46ecdd6.svg";
export { ForwardRef as ReactComponent };